import * as React from "react";
import { Parallax, Background } from "react-parallax";
import styled from "styled-components";
import { Img, WmkImage } from "wmk-image";
import { colors } from "../../vars/palette";
import Theme from "../../vars/ThemeOptions";
import { Col, Container, Row } from "react-bootstrap";

const ParallaxWrap = styled.div`
  background: white;
  position: relative;
  z-index: 100;
  .page-title {
    color: ${colors.hex("white")};
    font-family: ${Theme.font.head};
    margin: 0;
    line-height: 1;
    font-weight: 500;
    font-size: 38px;
  }
  .gatsby-image-wrapper,
  img {
    width: 100vw !important;
    height: 100vh !important;
    max-width: none;
  }
  .title-container {
    display: flex;
    align-items: center;
    min-height: 45vh;
    text-align: center;
  }
`;

type ParallaxHeroProps = {
  image: Img;
  strength?: number;
  style?: React.CSSProperties;
  title?: string;
};

const ParallaxHero = ({
  image,
  strength = 250,
  style = { minHeight: "45vh" },
  title,
}: ParallaxHeroProps) => {
  return (
    <ParallaxWrap>
      <Parallax strength={strength}>
        <div style={style}>
          {title && title === "Thank You!" ? (
            <Container className="title-container">
              <Row>
                <Col>
                  <h2 className="page-title">{title}</h2>
                </Col>
              </Row>
            </Container>
          ) : title ? (
            <Container className="title-container">
              <Row>
                <Col>
                  <h1 className="page-title">{title}</h1>
                </Col>
              </Row>
            </Container>
          ) : (
            <></>
          )}
        </div>
        <Background>
          <WmkImage image={image} />
        </Background>
      </Parallax>
    </ParallaxWrap>
  );
};

export default ParallaxHero;
